/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const CapabilityType = {
    RISK_FACTOR: 'RISK_FACTOR',
    WORK_ACTIVITY: 'WORK_ACTIVITY',
    COURSE: 'COURSE'
} as const;
export type CapabilityType = typeof CapabilityType[keyof typeof CapabilityType];

